import type { QueryClient } from "@tanstack/react-query";

import { tiktokConnectionQueryOptions } from "../query/tiktok-integration";

/** OAuth 成功回跳后取消陈旧请求并刷新一次连接快照。 */
export async function refreshTikTokConnectionAfterOAuthReturn(
  queryClient: QueryClient,
  workspaceId: string,
) {
  await queryClient.cancelQueries({
    queryKey: ["workspace", workspaceId, "tiktok"],
  });
  await queryClient.invalidateQueries({
    queryKey: tiktokConnectionQueryOptions(workspaceId).queryKey,
  });
  return queryClient.fetchQuery(tiktokConnectionQueryOptions(workspaceId));
}
